import React from "react";
import {GetLocation} from "datasync-core";
import {globals} from "../Globals/Globals";

let default_position = {latitude:48.8534100, longitude:2.3488000, city:"Paris"};
let locationSessionCache = null; // Session cache to store location
let isLocationFetching = false; // Flag to prevent multiple simultaneous calls

// Initialize session cache from sessionStorage if available
try {
    const cachedLocation = sessionStorage.getItem('openweather_location');
    if (cachedLocation) {
        locationSessionCache = JSON.parse(cachedLocation);
    }
} catch (e) {
    console.warn('OpenWeather: Could not load cached location from sessionStorage');
}

/**
 * Prototype : GetLocationV2 copied from GetLocation/datasync-core
 * Purpose : return position location as JSON object
 * Returns : {longitude:<city longitude>, latitude:<city latitude>, city:<city name>}
 */
const GetLocationV2 = async (p_o_getlocation) => {
    try {
        // Check if location is already cached for this session
        if (locationSessionCache) {
            if (globals.parameters.debugging) {
                console.log("OpenWeather:GetLocationV2 - Using cached location");
            }
            if (typeof p_o_getlocation.onLocation === 'function') {
                p_o_getlocation.onLocation(locationSessionCache);
            }
            return;
        }

        // Check if already fetching to prevent multiple simultaneous calls
        if (isLocationFetching) {
            if (globals.parameters.debugging) {
                console.log("OpenWeather:GetLocationV2 - Already fetching location");
            }
            return;
        }

        isLocationFetching = true;
        
        if (globals.parameters.debugging) {
            console.log("OpenWeather:GetLocationV2 - Fetching new location");
        }

        // Fetch IP address synchronously
        const ipRes = await fetch('https://api.ipify.org?format=json');
        const ipData = await ipRes.json();
        
        // Fetch location info from IP synchronously
        const locRes = await fetch(`https://ipapi.co/${ipData.ip}/json/`);
        const locData = await locRes.json();
        
        if (locData.latitude && locData.longitude) {
            const locationObj = { latitude: locData.latitude, longitude: locData.longitude, city: locData.city };
            
            // Cache the location for this session
            locationSessionCache = locationObj;
            
            // Also store in sessionStorage for persistence across component remounts
            try {
                sessionStorage.setItem('openweather_location', JSON.stringify(locationObj));
            } catch (e) {
                console.warn('OpenWeather: Could not save location to sessionStorage');
            }
            
            if (typeof p_o_getlocation.onLocation === 'function') {
                p_o_getlocation.onLocation(locationObj);
            } else {
                console.error("OpenWeather::GetLocation : onLocation callback not set !");
            }
        } else {
            console.error('OpenWeather::Could not determine location from IP.');
            if (typeof p_o_getlocation.onError === 'function') {
                p_o_getlocation.onError('Could not determine location from IP.');
            }
        }
    } catch (err) {
        console.error('OpenWeather::Failed to fetch IP or location.', err);
        if (typeof p_o_getlocation.onError === 'function') {
            p_o_getlocation.onError('Failed to fetch IP or location.');
        }
    } finally {
        isLocationFetching = false;
    }
};


const OpenWeather = (props) => {
  React.useEffect(() => {    
    getLocationProcedure ();
      return function cleanup() {
        console.log("OpenWeather::cleanup")
      }; 
    });

  const getLocationProcedure = () => {
    console.log("OpenWeather::getLocationProcedure")
    try {      
      if (navigator.geolocation) {
          //navigator.geolocation.getCurrentPosition(showPosition, showDefaultPosition,  { timeout: 1000000, maximumAge : 1000000, enableHighAccuracy: true });
          GetLocationV2({onLocation:(locationObj)=>{showPosition(locationObj)}, onError:(msg)=>{console.error(msg)}})
      } else {
          throw ("OpenWeather::Geolocation is not supported by this browser.");
      }
    } catch (error) {
        console.error(`OpenWeather::Geolocation refused with error:${error}`)
        //Set Paris as default position
        showPosition(default_position)
    }
  }

  const showPosition = (position) => {
    getWeather(position.latitude, position.longitude);
    getCity(position.latitude, position.longitude);
  }

  const showDefaultPosition = (positionError) => {
    console.error(`OpenWeather::Geolocation refused with error:${positionError.message}`)
    showPosition(default_position);
  }


  const getWeather = (lat, lon) => {
    var apiKey = '2ebfdf914d7c8c2c3d162ea50e42ee01';
    var url = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric&lang=fr`;

    fetch(url)
        .then(response => response.json())
        .then(data => {
            var weather = data.weather[0].description;
            var temperature = data.main.temp;
            var temp_min = data.main.temp_min;
            var temp_max = data.main.temp_max;
            var feels_like = data.main.feels_like;
            var humidity = data.main.humidity;
            var icon = data.weather[0].icon;
            //var iconUrl = `http://openweathermap.org/img/wn/${icon}.png`;
            var iconUrlDoubleSized = `http://openweathermap.org/img/wn/${icon}@2x.png`;

            {/*
            document.getElementById('weather-description').innerHTML = weather;
            document.getElementById('weather-temp').innerHTML = `${temperature}°C`;
            document.getElementById('weather-temp-min').innerHTML = `${temp_min}°C`;
            document.getElementById('weather-temp-max').innerHTML = `${temp_max}°C`;
            document.getElementById('weather-temp-feels').innerHTML = `${feels_like}°C`;
            document.getElementById('weather-humidity').innerHTML = `${humidity}%`;
            document.getElementById('weather-icon').src = iconUrlDoubleSized;
            */}
            document.getElementById('weather-temp').innerHTML = `${temperature}°C`;
            document.getElementById('weather-humidity').innerHTML = `${humidity}%`;
            document.getElementById('weather-icon').src = iconUrlDoubleSized;
        })
        .catch(error => console.error('Erreur:', error));
  }

const getCity = (lat, lon) => {
  const limit = 1;
  var apiKey = '2ebfdf914d7c8c2c3d162ea50e42ee01';
  var url = `https://api.openweathermap.org/geo/1.0/reverse?lat=${lat}&lon=${lon}&limit=${limit}&appid=${apiKey}`

  fetch(url)
        .then(response => response.json())
        .then(data => {
            console.log("getCity ->", data);
            var city = data[0].name;

            document.getElementById('weather-city').innerHTML = `${city}`;
        })
        .catch(error => console.error('OpenWeather::Erreur:', error));
}

  return (
    <div id="weather-container">
      <div id="weather-city"/>
      <img id="weather-icon" src="" alt="Weather Icon"/>
      <div className="title"><span id="weather-temp"/></div>
      <div className="title"><span id="weather-humidity"></span></div>
    </div>
  );
};

export default OpenWeather;